import React, { useState } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { useSearchTerm } from '../hooks/useSearchTerm';
import { useSyncPageParams } from '../hooks/useSyncPageParams';
import { useClampPage } from '../hooks/useClampPage';
import { useGetAllEventTemplate } from '../services/react-query/event_templates';
import { Loading } from '../uikit';
import AppLink from '../components/common/AppLink/AppLink';
import StickyTableHeader from '../components/common/StickyTableHeader';
import ListHeader from '../components/listHeader/ListHeader';
import FilterSidebar from '../components/common/filters/FilterSidebar';
import { UserConfigurableModule } from '../types/User';
import { archiveFilter } from '../components/common/filters/consts';
import { FilterState, IFilter } from '../components/common/filters/interfaces';
import { ROUTE_PATHS } from '../routes/Routes';
import {
  defaultContainerStyling,
  listPageLayoutStyles,
  listPageTableRowStyling,
  listPageTableWrapperStyles,
} from '../styles/sxStyling';
import ListBottomBar from '../components/common/ListBottomBar/ListBottomBar';

export default function EventTemplatesList() {
  const { currentPage, setCurrentPage } = useSyncPageParams();
  const [filterState, setFilterState] = useState<FilterState>(undefined);

  const { data, isLoading } = useGetAllEventTemplate({
    params: {
      page: currentPage,
      search: useSearchTerm(),
      filters: filterState,
    },
    enabled: true,
  });

  useClampPage(currentPage, data?.meta?.total_pages, setCurrentPage);

  if (isLoading) return <Loading />;

  const eventTemplates = data?.data || [];
  const meta = data?.meta;

  const moduleFilters: IFilter[] = [archiveFilter];
  const headerCells = ['Name', 'Description', 'Field Count'];

  return (
    <Box>
      <ListHeader title="Event Templates" />

      <Box sx={listPageLayoutStyles}>
        <FilterSidebar
          moduleFilters={moduleFilters}
          module={UserConfigurableModule.EVENT_TEMPLATES}
          activeFilter={filterState}
          setActiveFilter={setFilterState}
        />

        <Box sx={listPageTableWrapperStyles}>
          <TableContainer sx={defaultContainerStyling}>
            <Table>
              <StickyTableHeader cells={headerCells} />
              <TableBody>
                {eventTemplates.map((template) => (
                  <TableRow key={template.uuid} sx={{ ...listPageTableRowStyling }}>
                    <TableCell>
                      <AppLink to={`/${ROUTE_PATHS.EVENT_TEMPLATES}/${template.uuid}`}>{template.name}</AppLink>
                    </TableCell>
                    <TableCell>{template.description}</TableCell>
                    <TableCell>{template.fields?.length || 0}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <ListBottomBar page={currentPage} meta={meta} onChange={(_e, v) => setCurrentPage(v)} />
        </Box>
      </Box>
    </Box>
  );
}
